import React from "react";
import "./live-news-collection.m.css";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import StoryCard25 from "../../molecules/story-card25";
import StoryCard26 from "../../molecules/story-card26";
import Separator from "../../atoms/separator";

const LiveElectionCollection = ({ collection, index }) => {
  if (!collection || !collection.items || collection.items.length === 0) return null;
  const mainStory = collection.items[0].story;
  const embed = collection["associated-metadata"]?.["election embed"] || "";
  const value = embed !== "" ? 0 : 1;
  const sideStories = collection.items.slice(value).map((item) => item.story);

  return (
    <div styleName="collection-wrapper">
      <div styleName="collection-container">
        <CollectionTitleHeader hasDarkBg={true} collection={collection} index={index} />

        <div styleName="live-grid">
          <div styleName="main-story">
            {embed !== "" ? <div dangerouslySetInnerHTML={{ __html: embed }}></div> : <StoryCard25 story={mainStory} />}
          </div>

          <div styleName="side-stories">
            {sideStories.length > 0 && (
              <div styleName="side-story-large">
                <StoryCard26 story={sideStories[0]} bigCard={true} />
              </div>
            )}
            {sideStories.length > 1 && (
              <div styleName="side-story-grid">
                {sideStories.slice(1, 3).map((story, idx) => (
                  <StoryCard26 story={story} key={idx} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <Separator />
    </div>
  );
};

export default LiveElectionCollection;
